import { render, staticRenderFns } from "./webType.vue?vue&type=template&id=22f45c43&"
import script from "./webType.vue?vue&type=script&lang=js&"
export * from "./webType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports